require("@babel/polyfill");
// require("./utils/events.ts");

import {Application} from "./application/application";
import {ComponentService} from "./service/component";

(($) => $(() => {

    let components = new ComponentService();
    new Application(components);

}))(jQuery);